import { reduxForm } from 'redux-form'
import at from 'lodash/at'
import get from 'lodash/get'

import { goBack } from 'react-router-redux'
import { setAmountFilterForLocation } from '../../actions/work-tracker-filters'

import WorkTrackerFilterModal from '../../components/work-trackers/work-tracker-filter-modal'

const fields = [
  'resourceId'
]

function mapStateToProps (state, ownProps) {
  const id = ownProps.params.locationId
  const resources = [
    { id: 0, name: '0' },
    { id: 1, name: '1' },
    { id: 2, name: '2' },
    { id: 3, name: '3' },
    { id: 4, name: '4' },
    { id: 5, name: '5+' }
  ]

  return {
    resourceType: 'checkbox',
    resourceName: 'amount',
    modalTitle: 'Choose an Amount',
    hasNextPage: false,
    initialValues: {
      resourceId: get(state, `workTrackerFilters.${id}.amountIds`, [])
    },
    resources
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  const id = ownProps.params.locationId

  return {
    handleClose () {
      dispatch(goBack())
    },

    onSubmit (data) {
      dispatch(setAmountFilterForLocation(id, data.resourceId))
      dispatch(goBack())
    }
  }
}

export default reduxForm(
  {
    fields,
    form: 'workTrackerAmountFilter'
  },
  mapStateToProps,
  mapDispatchToProps
)(WorkTrackerFilterModal)



// WEBPACK FOOTER //
// ./src/containers/work-trackers/work-tracker-amount-filter-container.js